(function () {
  "use strict";

  // ------------------------------------------------------------------
  // Header scroll state
  // ------------------------------------------------------------------
  const header = document.getElementById("site-header");

  function updateHeaderState() {
    if (!header) return;
    if (window.scrollY > 8) {
      header.classList.add("is-scrolled");
    } else {
      header.classList.remove("is-scrolled");
    }
  }

  updateHeaderState();
  window.addEventListener("scroll", updateHeaderState, { passive: true });

  // ------------------------------------------------------------------
  // Mobile drawer
  // ------------------------------------------------------------------
  const menuBtn = document.getElementById("menu-open-btn");
  const drawer = document.getElementById("mobile-drawer");
  const drawerOverlay = document.getElementById("drawer-overlay");
  const drawerLinks = drawer ? drawer.querySelectorAll("a") : [];

  function openDrawer() {
    if (!drawer || !drawerOverlay || !menuBtn) return;
    drawer.classList.add("is-open");
    drawerOverlay.classList.add("is-open");
    menuBtn.setAttribute("aria-expanded", "true");
    menuBtn.setAttribute("aria-label", "Zamknij menu");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    if (!drawer || !drawerOverlay || !menuBtn) return;
    drawer.classList.remove("is-open");
    drawerOverlay.classList.remove("is-open");
    menuBtn.setAttribute("aria-expanded", "false");
    menuBtn.setAttribute("aria-label", "Otwórz menu");
    document.body.style.overflow = "";
  }

  function toggleDrawer() {
    if (!drawer) return;
    if (drawer.classList.contains("is-open")) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  if (menuBtn) menuBtn.addEventListener("click", toggleDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener("click", closeDrawer);
  drawerLinks.forEach((link) => link.addEventListener("click", closeDrawer));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeDrawer();
  });

  // ------------------------------------------------------------------
  // Smooth scroll for in-page anchor links (JS-driven so it doesn't
  // depend on the browser/OS "reduce motion" setting silently disabling
  // the CSS scroll-behavior: smooth rule)
  // ------------------------------------------------------------------
  document.addEventListener("click", (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const targetId = link.getAttribute("href");
    if (!targetId || targetId === "#") return;

    const target = document.querySelector(targetId);
    if (!target) return;

    event.preventDefault();
    closeDrawer();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    if (history.pushState) history.pushState(null, "", targetId);
  });

  // ------------------------------------------------------------------
  // FAQ accordion
  // ------------------------------------------------------------------
  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((item) => {
    const trigger = item.querySelector(".accordion-trigger");
    if (!trigger) return;

    trigger.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");

      accordionItems.forEach((other) => {
        other.classList.remove("is-open");
        const otherTrigger = other.querySelector(".accordion-trigger");
        if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
      });

      if (!isOpen) {
        item.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      }
    });
  });

  // ------------------------------------------------------------------
  // Gallery — fetched from gallery-api.php (backed by the admin panel's
  // SQLite database) instead of being hardcoded in the HTML, so Natalia
  // i Sandra can manage photos themselves through admin/.
  // ------------------------------------------------------------------
  const filterContainer = document.getElementById("gallery-filters");
  const galleryGrid = document.getElementById("gallery-grid");
  const galleryEmpty = document.getElementById("gallery-empty");

  const galleryZoomIcon =
    '<svg viewBox="0 0 256 256" fill="currentColor"><path d="M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM144,120H120v24a8,8,0,0,1-16,0V120H80a8,8,0,0,1,0-16h24V80a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z"/></svg>';

  function escapeHtml(str) {
    const div = document.createElement("div");
    div.textContent = str == null ? "" : String(str);
    return div.innerHTML;
  }

  function galleryItemMarkup(photo) {
    const alt = escapeHtml(photo.alt || "Realizacja Balonowe Atelier");
    const categories = Array.isArray(photo.categories) ? photo.categories.join(" ") : "";
    return (
      '<button type="button" class="gallery__item" data-categories="' +
      escapeHtml(categories) +
      '">' +
      "<picture>" +
      '<source media="(max-width: 640px)" srcset="' +
      escapeHtml(photo.mobile) +
      '" />' +
      '<img src="' +
      escapeHtml(photo.desktop) +
      '" alt="' +
      alt +
      '" loading="lazy" decoding="async" />' +
      "</picture>" +
      '<span class="gallery__item-overlay">' +
      '<span class="gallery__item-caption">' +
      galleryZoomIcon +
      alt +
      "</span>" +
      "</span>" +
      "</button>"
    );
  }

  function activateFilterButton(button) {
    document.querySelectorAll("#gallery-filters .filter-pill").forEach((btn) => {
      btn.classList.remove("is-active");
      btn.setAttribute("aria-pressed", "false");
    });
    button.classList.add("is-active");
    button.setAttribute("aria-pressed", "true");
  }

  function bindFilterButton(button) {
    button.addEventListener("click", () => {
      const filter = button.dataset.filter;
      activateFilterButton(button);

      document.querySelectorAll(".gallery__item").forEach((item) => {
        const itemCategories = (item.dataset.categories || "").split(" ").filter(Boolean);
        const matches = filter === "all" || itemCategories.indexOf(filter) !== -1;
        item.hidden = !matches;
      });
    });
  }

  function loadGallery() {
    if (!galleryGrid) return;

    fetch("gallery-api.php")
      .then((res) => res.json())
      .then((data) => {
        const categories = Array.isArray(data.categories) ? data.categories : [];
        const photos = Array.isArray(data.photos) ? data.photos : [];

        if (filterContainer) {
          categories.forEach((category) => {
            const button = document.createElement("button");
            button.type = "button";
            button.className = "filter-pill";
            button.dataset.filter = category.slug;
            button.setAttribute("aria-pressed", "false");
            button.textContent = category.name;
            filterContainer.appendChild(button);
            bindFilterButton(button);
          });
        }

        if (photos.length === 0) {
          if (galleryEmpty) galleryEmpty.hidden = false;
          return;
        }
        galleryGrid.innerHTML = photos.map(galleryItemMarkup).join("");
      })
      .catch(() => {
        if (galleryEmpty) {
          galleryEmpty.hidden = false;
          galleryEmpty.textContent = "Nie udało się załadować galerii.";
        }
      });
  }

  loadGallery();

  document.querySelectorAll("#gallery-filters .filter-pill").forEach(bindFilterButton);

  const lightbox = document.getElementById("lightbox");
  const lightboxImage = document.getElementById("lightbox-image");
  const lightboxCaption = document.getElementById("lightbox-caption");
  const lightboxClose = document.getElementById("lightbox-close");
  const lightboxOverlay = document.getElementById("lightbox-overlay");

  function openLightbox(src, caption) {
    if (!lightbox || !lightboxImage || !lightboxCaption) return;
    lightboxImage.setAttribute("src", src);
    lightboxImage.setAttribute("alt", caption);
    lightboxCaption.textContent = caption;
    lightbox.classList.add("is-open");
    if (lightboxOverlay) lightboxOverlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove("is-open");
    if (lightboxOverlay) lightboxOverlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  // Delegated on the grid container so it keeps working for gallery
  // items rendered dynamically by loadGallery().
  if (galleryGrid) {
    galleryGrid.addEventListener("click", (event) => {
      const item = event.target.closest(".gallery__item");
      if (!item) return;
      const img = item.querySelector("img");
      if (!img) return;
      openLightbox(img.getAttribute("src"), img.getAttribute("alt") || "");
    });
  }

  if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);
  if (lightboxOverlay) lightboxOverlay.addEventListener("click", closeLightbox);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeLightbox();
  });

  // ------------------------------------------------------------------
  // Contact form — photo attachment filename preview
  // ------------------------------------------------------------------
  const photoInput = document.getElementById("photo");
  const photoDropzone = document.getElementById("photo-dropzone");
  const photoFilename = document.getElementById("photo-filename");
  const photoDefaultLabel = "Dodaj zdjęcie (JPG, PNG, max 10 MB)";

  if (photoInput && photoDropzone && photoFilename) {
    photoInput.addEventListener("change", () => {
      const file = photoInput.files && photoInput.files[0];
      if (file) {
        photoFilename.textContent = file.name;
        photoDropzone.classList.add("has-file");
      } else {
        photoFilename.textContent = photoDefaultLabel;
        photoDropzone.classList.remove("has-file");
      }
    });
  }

  // ------------------------------------------------------------------
  // Contact form — wysyłane przez send.php (PHPMailer/SMTP)
  // ------------------------------------------------------------------
  const contactForm = document.getElementById("contact-form");
  const contactSuccess = document.getElementById("contact-success");
  const contactError = document.getElementById("contact-error");
  const contactSubmitBtn = document.getElementById("contact-submit");
  const contactSubmitDefaultLabel = contactSubmitBtn ? contactSubmitBtn.innerHTML : "";

  if (contactForm) {
    contactForm.addEventListener("submit", (event) => {
      event.preventDefault();

      if (contactError) contactError.hidden = true;
      if (contactSubmitBtn) {
        contactSubmitBtn.disabled = true;
        contactSubmitBtn.textContent = "Wysyłanie...";
      }

      fetch("send.php", {
        method: "POST",
        body: new FormData(contactForm),
      })
        .then((res) => res.json().then((data) => ({ ok: res.ok, data: data })))
        .then(({ ok, data }) => {
          if (!ok || !data.ok) throw new Error(data.message || "Nie udało się wysłać wiadomości.");
          contactForm.hidden = true;
          if (contactSuccess) contactSuccess.hidden = false;
        })
        .catch((err) => {
          if (contactError) {
            contactError.textContent = err.message || "Nie udało się wysłać wiadomości.";
            contactError.hidden = false;
          }
        })
        .finally(() => {
          if (contactSubmitBtn) {
            contactSubmitBtn.disabled = false;
            contactSubmitBtn.innerHTML = contactSubmitDefaultLabel;
          }
        });
    });
  }
})();
